export function envToBool(value: string | undefined, envName: string = '') {
    if (envName) {
        console.log(envName, value)
    }
    return `${value}`?.toLowerCase() === 'true'
}
